import React from "react";
import { Lines, FadeUp } from "../components/Reveal";

const CHAPTERS = [
    ["01", "Transformation", "The snake sheds. So do you. Every piece is built for the person you are becoming."],
    ["02", "Movement", "Cut for motion. Weighted for presence. Clothing that keeps pace with ambition."],
    ["03", "Perspective", "The world looks different from the top. Own the view. Own your perspective."],
];

export default function Manifesto() {
    return (
        <section id="manifesto" data-testid="brand-statement" className="bg-[#0A0A0A] px-5 py-28 text-[#F2F0EA] sm:px-8 lg:px-16 lg:py-40">
            <div className="mx-auto max-w-[1600px]">
                <p className="mb-10 text-[9px] uppercase tracking-[0.4em] text-[#8E8D8A]">05 — Manifesto</p>
                <h2 className="font-display text-[13vw] font-black uppercase leading-[0.88] tracking-tighter sm:text-[9vw] lg:text-[8vw]">
                    <Lines lines={["Own Your", "Perspective."]} />
                </h2>
                <div className="mt-20 grid grid-cols-1 gap-12 border-t border-[rgba(242,240,234,0.15)] pt-14 md:grid-cols-3 lg:mt-28">
                    {CHAPTERS.map(([num, title, copy], i) => (
                        <FadeUp key={num} delay={i * 0.12}>
                            <p className="font-display text-[10px] font-bold tracking-[0.35em] text-[#8E8D8A]">{num}</p>
                            <h3 className="font-display mt-4 text-lg font-extrabold uppercase tracking-tight">{title}</h3>
                            <p className="mt-4 max-w-xs text-sm leading-relaxed text-[#6B6A66]">{copy}</p>
                        </FadeUp>
                    ))}
                </div>
                <p className="mt-20 text-[9px] uppercase tracking-[0.45em] text-[#8E8D8A]">Vantage Owners Club — Est. 2026</p>
            </div>
        </section>
    );
}
